module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4r3n1n2n-2553050cde2a5406a3e26ca9fd8de28b.svg";